// extracted by mini-css-extract-plugin
module.exports =  {"menu":"_35875ce240--menu--NKvUe","menu-item":"_35875ce240--menu-item--EVu_c","menu-item--active":"_35875ce240--menu-item--active--z0FyG"};